import { useBreakpoint } from './useBreakpoint'
import type { Breakpoint } from 'shared/types/Breakpoint'

export const useBreakpointQuery = (
    breakpoints: Breakpoint | Breakpoint[],
    options?: Parameters<typeof useBreakpoint>[0]
): boolean => {
    const { breakpoint } = useBreakpoint(options)

    return Array.isArray(breakpoints)
        ? breakpoints.includes(breakpoint)
        : breakpoint === breakpoints
}

export const useIsMobile = (options?: Parameters<typeof useBreakpoint>[0]): boolean => {
    const { isMobile } = useBreakpoint(options)

    return isMobile
}

export const useIsTablet = (options?: Parameters<typeof useBreakpoint>[0]): boolean => {
    const { isTablet } = useBreakpoint(options)

    return isTablet
}

export const useIsDesktop = (options?: Parameters<typeof useBreakpoint>[0]): boolean => {
    const { isDesktop } = useBreakpoint(options)

    return isDesktop
}


export const useBreakpointDown = (
    targetBreakpoint: Breakpoint,
    options?: Parameters<typeof useBreakpoint>[0]
): boolean => {
    const { breakpoint } = useBreakpoint(options)
    const breakpointOrder: Breakpoint[] = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl']

    const currentIndex = breakpointOrder.indexOf(breakpoint)
    const targetIndex = breakpointOrder.indexOf(targetBreakpoint)

    return currentIndex <= targetIndex
}

export const useBreakpointUp = (
    targetBreakpoint: Breakpoint,
    options?: Parameters<typeof useBreakpoint>[0]
): boolean => {
    const { breakpoint } = useBreakpoint(options)
    const breakpointOrder: Breakpoint[] = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];

    const currentIndex = breakpointOrder.indexOf(breakpoint)
    const targetIndex = breakpointOrder.indexOf(targetBreakpoint)

    return currentIndex >= targetIndex
}

export const useBreakpointBetween = (
    min: Breakpoint,
    max: Breakpoint,
    options?: Parameters<typeof useBreakpoint>[0]
): boolean => {
    const { breakpoint } = useBreakpoint(options)
    const breakpointOrder: Breakpoint[] = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl']

    const currentIndex = breakpointOrder.indexOf(breakpoint)
    const minIndex = breakpointOrder.indexOf(min)
    const maxIndex = breakpointOrder.indexOf(max)

    return currentIndex >= minIndex && currentIndex <= maxIndex
}